// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const DoorDetailsContainer = styled.div(
  ({ type }) => css`
  height: ${type === "NOMINAL" ? "812px" : "480px"};
  width: 640px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  outline: none;
  padding: 60px;
  // padding-right: 20px;
`);

export const PromoCodeInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FirstInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NotificationDate = styled.text`
  font-size: 12px;
  color: ${COLORS.primaryGray};
  font-family: ${FONTS.montserrat};
  margin-left: 5px;
`;

export const NotificationDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // width: 100%;
  // padding-bottom: 10px;
  // margin-bottom: 10px;
`;

export const ClockIconImage = styled.img``;

export const InfoLine = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Info = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-right: 10px;
  margin-bottom: 20px;
`;

export const Value = styled.div`
    font-size: 16px;
    color: ${COLORS.rainbowIndigo};
    font-family: ${FONTS.montserrat};
`;

export const PromoCodeType = styled.div`
  font-size: 16px;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  margin-bottom: 20px;
`;

export const NotificationTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  margin-bottom: 5px;
  display: flex;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
`;

export const  UsersList = styled.div`
  height: 280px;
  width: 520px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  padding-right: 20px;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 47.8px;
  width: 490px;
  align-items: center;
  border-bottom: 3px solid #EAE8E8;
  cursor: pointer;
`;

export const CheckBox = styled.div(
  ({ isSelected }) => css`
  width: 16px;
  height: 16px;
  margin-right: 20px;
  border-radius: 50px;
  border: 1px solid ${COLORS.rainbowIndigo};
  background-color: ${isSelected ? COLORS.rainbowIndigo : "transparent"};
  `);

export const UserIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 12px;
  border-radius: 50px;
  background-color: ${COLORS.secondaryGray}
`;

export const UserName = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  height: 48px;
  display: flex;
  align-items: center;
  `;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    width: ${width ? width : "300px"};
    @media screen and (min-width: 1451px) {
      margin-right: 80px;
    }
    @media screen and (max-width: 1450px) {
      margin-right: 30px;
    }
  `
);

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;
export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div(
  ({ color }) => css`
    font-size: 30px;
    font-family: ${FONTS.newsharp};
    color: ${color ? color : COLORS.cornflowerBlue};
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
  `
);

export const TitleContainer = styled.div(
  ({ color }) => css`
    display: flex;
    flex-direction: row;
    color: ${color ? color : COLORS.cornflowerBlue};
  `
);

export const LockerIcon = styled(LockIcon)(
  ({ color }) => css`
    && {
      margin-right: 10px;
      color: ${color ? color : COLORS.cornflowerBlue};
    }
    &.MuiSvgIcon-root {
      height: 33px;
    }
  `
);

export const Status = styled.text(
  ({ color }) => css`
    font-size: 22px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.rainbowIndigo};
    font-weight: 600;
  `
);

export const EquipmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const Subtitle = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
`;

export const EquipmentContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 25px;
`;

export const EquipmentDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const EquipmentName = styled.text`
  font-size: 16px;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  margin-right: 20px;
`;

export const EquipmentStatus = styled.text(
  ({ color }) => css`
    font-size: 14px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.primaryGreen};
    font-weight: 600;
  `
);

export const Bar = styled.div`
  height: 2px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonContainer = styled.div`
  margin: 0 auto;
  margin-top: 20px;
`;

export const ActionIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 40px;
  cursor: pointer;
`;

export const ChangeStatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  height: 40px
`;

export const PromoCodeStatus = styled.div`
  font-size: 16px;
  color: ${COLORS.terraCotta};
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  margin-left: 10px;      
`;
